import _find from 'lodash/find';
import { WS_TOPIC_ASYNC } from '../constants/App';
import { REGISTER_ASYNC_OPERATION, CPM_REGISTER_OPERATION } from '../constants/ActionTypes';
import { wsJoinTopic, wsSendSubscription } from '../actions';
// Models
/* eslint-disable import/named */
import { subOperationUpdated } from '../models/cpm/synchronization';
/* eslint-enable import/named */

const webSocketPreProcess = (store) => (next) => (action) => {
  let asyncOperationId;
  let operationId;

  switch (action.type) {
    case REGISTER_ASYNC_OPERATION:
      // Check if websocket is open: if not, do not try to join async operation topic
      if (store.getState().webSocket.open) {
        asyncOperationId = action.asyncOperation.id;
        // Call next to join topic for the new async operation (only if the async operation is not already registered)
        if (!_find(store.getState().asyncOperation.list, ['id', asyncOperationId])) {
          // For webSocketService
          next(wsJoinTopic(`${WS_TOPIC_ASYNC}:${asyncOperationId}`, asyncOperationId));
        }
        next(action);
      }
      break;
    case CPM_REGISTER_OPERATION:
      // Check if websocket is open: if not, do not susbcribe to operation updated
      if (store.getState().webSocket.open) {
        operationId = action.operation.id;
        // Call next to send subscription to be notified of an update of this operation (only if the operation is not already registered)
        if (!_find(store.getState().cpmOperation.list, ['id', operationId])) {
          next(wsSendSubscription(operationId, subOperationUpdated, { id: operationId }));
        }
        next(action);
      }
      break;

    default:
      next(action);
      break;
  }
};

export default webSocketPreProcess;



// WEBPACK FOOTER //
// ./middlewares/webSocketPreProcess.js